class MainBlog extends HTMLElement {
  constructor() {
    super();
    this.id = this.dataset.id;
    this.tagLinks = this.querySelectorAll("[data-tag-link]");
    this.handleClick = this.handleClick.bind(this);
    this.addEventListener("click", this.handleClick);

    this.tagLinks.forEach((link) =>
      link.addEventListener("click", (e) => this.handleLinkClick(e)),
    );

    this.scrollActiveTagIntoView();
  }

  /**
   * Centres the tag the page loaded on, which may sit outside the visible run
   * of the scroller. Sets scrollLeft rather than calling scrollIntoView, which
   * would also scroll the page when the tag row starts below the fold.
   */
  scrollActiveTagIntoView() {
    const scroller = this.querySelector("[data-tag-list]");
    const active = scroller?.querySelector("[data-tag-link].active");
    if (!active) return;

    const scrollerRect = scroller.getBoundingClientRect();
    const activeRect = active.getBoundingClientRect();

    scroller.scrollLeft +=
      activeRect.left -
      scrollerRect.left -
      (scrollerRect.width - activeRect.width) / 2;
  }

  async handleClick(e) {
    const loadMore = e.target.closest("[data-load-more]");
    if (!loadMore) return;

    e.preventDefault();

    await this.revealNextPage(loadMore);
  }

  revealNextPage(loadMore) {
    const url = loadMore.dataset.url;
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const articlesNew = html.querySelectorAll("[data-article]");
        const articlesContainerOld = this.querySelector("[data-blog-grid]");
        const loadMoreWrapperNew = html.querySelector(
          "[data-load-more-wrapper]",
        );
        const loadMoreWrapperOld = this.querySelector(
          "[data-load-more-wrapper]",
        );

        loadMoreWrapperOld.innerHTML = loadMoreWrapperNew.innerHTML;

        articlesNew.forEach((article) =>
          articlesContainerOld.appendChild(article),
        );
      });
  }

  handleLinkClick(event) {
    event.preventDefault();

    this.tagLinks.forEach((link) =>
      link.classList.toggle("active", link === event.currentTarget),
    );
    this.renderPage(event.currentTarget.dataset.url);
  }

  renderPage(url) {
    this.setLoading();
    const fetchUrl = `${url}?section_id=${this.id}`;
    this.renderArticles(fetchUrl, event);
    this.updateURLHash(url);
  }

  renderArticles(url) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        this.renderContent(html);
        this.setDoneLoading();
      });
  }

  renderContent(html) {
    this.querySelector("[data-content]").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector("[data-content]").innerHTML;
  }

  setLoading() {
    this.querySelector("[data-blog-grid]").classList.add("loading");
  }

  setDoneLoading() {
    this.querySelector("[data-blog-grid]").classList.remove("loading");
  }

  updateURLHash(url) {
    window.history.replaceState({}, "", url);
  }
}

if (!customElements.get("main-blog")) {
  customElements.define("main-blog", MainBlog);
}
